import { NgModule } from '@angular/core';
import { TeregistrasiComponent } from './distributor-list/teregistrasi/teregistrasi.component';
import { DistributorRoutingModule } from './distributor-routing.module';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { TeregistrasiActiveComponent } from './distributor-list/teregistrasi/teregistrasi-active/teregistrasi-active.component';
import { TeregistrasiRegisteredComponent } from './distributor-list/teregistrasi/teregistrasi-registered/teregistrasi-registered.component';
import { PendingComponent } from './distributor-list/pending/pending.component';
import { RegistrationComponent } from './distributor-list/pending/registration/registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerificationComponent } from './distributor-list/pending/verification/verification.component';
import { ComponentsModule } from '@shared/components/components.module';
import { CardDetailBodyColComponent } from '@shared/components/card/card-detail-body-col/card-detail-body-col.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { RejectComponent } from './distributor-list/reject/reject.component';
import { RegistrationRejectComponent } from './distributor-list/reject/registration-reject/registration-reject.component';
import { VerificationRejectComponent } from './distributor-list/reject/verification-reject/verification-reject.component';
import { MatMenuModule } from '@angular/material/menu';
import { DocumentTestComponent } from '../products/detail-products/document-test/document-test.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { SwiperModule } from 'swiper/angular';
import { EditRequestComponent } from './distributor-list/pending/edit-request/edit-request.component';
import { FilterListDistributorComponent } from './components/filter-list-distributor/filter-list-distributor.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { CardTableListComponent } from './components/card-table-list/card-table-list.component';
import { DetailDistributorLogComponent } from './distributor-detail/detail-log/detail-distributor-log.component';
import { DetailRejectComponent } from './distributor-detail/detail-reject/detail-reject.component';
import { DistributorDetailComponent } from './distributor-detail/distributor-detail.component';
import { DistributorDetailModule } from './distributor-detail/distributor-detail.module';
import { VerificationTabInformasiKULComponent } from './distributor-detail/detail-pending/detail-verification/verification-tab-informasi-kul/verification-tab-informasi-kul.component';
import { DocumentDistributorComponent } from './distributor-detail/detail-teregistrasi/components/document-distributor/document-distributor.component';
import { TeregistrasiNonActiveComponent } from './distributor-list/teregistrasi/teregistrasi-non-active/teregistrasi-non-active.component';
import { NonActiveComponent } from './distributor-list/pending/non-active/non-active.component';

@NgModule({
  declarations: [
    TeregistrasiComponent,
    TeregistrasiActiveComponent,
    TeregistrasiRegisteredComponent,
    PendingComponent,
    RegistrationComponent,
    VerificationComponent,
    CardDetailBodyColComponent,
    RejectComponent,
    RegistrationRejectComponent,
    VerificationRejectComponent,
    // DocumentKULComponent,
    DocumentTestComponent,
    EditRequestComponent,
    FilterListDistributorComponent,
    CardTableListComponent,
    DetailDistributorLogComponent,
    DetailRejectComponent,
    DistributorDetailComponent,
    VerificationTabInformasiKULComponent,
    DocumentDistributorComponent,
    TeregistrasiNonActiveComponent,
    NonActiveComponent,
  ],
  imports: [
    DistributorRoutingModule,
    MatTabsModule,
    CommonModule,
    InlineSVGModule,
    NgxSkeletonLoaderModule,
    MatTableModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    GoogleMapsModule,
    MatMenuModule,
    NgbPopoverModule,
    SwiperModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatStepperModule,
    DistributorDetailModule,
  ],
  exports: [
    // modules
    MatTabsModule,
    MatStepperModule,
    MatButtonModule,
    MatMenuModule,
    InlineSVGModule,
    ComponentsModule,
    GoogleMapsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    // NgxPrintElementModule,
    NgbPopoverModule,
    // components;
    DocumentTestComponent,
  ],
})
export class DistributorModule {}
